import {useTheme} from '@mui/material';

export default function ArrowBackIcon() {
	const theme = useTheme();
	// @ts-ignore
	const color = theme.palette.mode === 'light' ? theme.palette.primary[400] : theme.palette.primary[50];
	return (
		<svg className="ltr:-scale-100" width="24" height="24" viewBox="0 0 24 24" fill="none">
			<path d="M14.4302 5.92993L20.5002 11.9999L14.4302 18.0699" stroke={color} strokeWidth="2" strokeMiterlimit="10"
			      strokeLinecap="round" strokeLinejoin="round"/>
			<path d="M3.5 12H20.33" stroke={color} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round"
			      strokeLinejoin="round"/>
		</svg>
	);
}
